<!-- start header  -->
<header>
		<app-head (newItemEvent)="addItem($event)" [titleModule]="'inquiries'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0">
		<!-- start sidebar  -->
		<app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'inquiries'"></app-sidebar>
		<!-- end sidebar  -->
		<!-- start content page  -->
		<main class="p-4 col-lg-10 ">
				<div class="fw-inquiries d-flex justify-content-between" style="color: #6c6a6a;margin-top: 8px; margin-bottom: 16px;">
						<p class="fw-bold ms-1" style="color: #6c6a6a;">inquiries</p>
						<div class="d-flex justify-content-lg-between  ">
								<!-- <app-dropdown class="ms-3" [list]="listDropDown" (selected)="selectedfromDropDown($event)"></app-dropdown> -->

								<app-dropdown class="me-3" [list]="listDropDown" (selected)="selectedfromDropDown($event)"></app-dropdown>
								<div class="d-flex mb-2  ">
										<button class="week rounded-start px-3 py-2 bg-w outline-none" (click)="FilterButtons('This Month')"
												[ngClass]="{'activeButton': monthButton == true}">This Month</button>
										<button class="week px-3 py-2 outline-none rounded-end" (click)="FilterButtons('Last Week')"
												[ngClass]="{'activeButton': weekButton == true}">Last Week</button>
								</div>
						</div>
						<!-- start add button (add new apartment) in page  -->
						<!-- end add button (add new apartment) in page  -->

				</div>

				<!-- start part 1 in page  -->

				<p-toast></p-toast>

				<!-- end part 1 in page  -->
				<!-- start part 2 in page  -->
<!------------------------------------------------------------------------------------------>
				<!-- <div class="card">
						<div class="row d-block d-md-flex justify-content-between align-items-center my-2  p-3">
							 
								<div class="col-md-4">
										<div class="d-flex align-items-center" style="font-size: 15px;">
												<label for="" style="color: #313331;font-weight: 500;font-size: 16px;">Inquiries</label>
												<img src="assets/images/line.svg" class="mx-3">
												<select class="form-select" (change)="clickIquires($event)">
														<option *ngFor="let data of InquireFillterLists; let index=index;" [value]="data.id"
																[selected]="InquireFillterSelected[index]">{{ data.name }}</option>
												</select>
										</div>
								</div>
 
								<div class="col-md-5 col-8">
										<div class="input">
												<input type="text" class="form-control py-2" placeholder=" Search by Inquires" (keyup)="searchAction($event) "
														[(ngModel)]="searchText" />
												<img src="../../../assets/images/search.svg" alt="">
										</div>
								</div>
						</div>

						 


						<p-table class="table-shopping" [selectionPageOnly]="true" [tableStyle]="{'min-width': '50rem' ,'min-': '50rem'}"
								[value]="Inquires"  [customSort]="true"
								(sortFunction)="customSort($event)" >
								<ng-template pTemplate="header" class="text-center">
										<tr *ngIf="headerData">
												<ng-container>

													 
														<th class="td-name">
																Inquiry Id

														</th>
														<th class="td-name">
																User name

														</th>

														<th class="td-name">
																Requested Appartment

														</th>
														<th class="td-name">
																Contact number

														</th>
														<th class="td-name"   pSortableColumn="rent_Duration">
																Time period<p-sortIcon field="rent_Duration"></p-sortIcon>
															 

														</th>
														<th class="td-name" pSortableColumn="upcoming">
															Booking Type<p-sortIcon field="upcoming"></p-sortIcon>
														 

													</th>
														<th class="td-name" pSortableColumn="status">
																Status<p-sortIcon field="status"></p-sortIcon>
																 

														</th>


														<th class="td-name">

														</th>
												</ng-container>
										</tr>
								</ng-template>
								<ng-template pTemplate="body" let-inquire>

										<tr style="cursor: pointer;" (click)="hidecard(inquire.booking_ID)">
											 
												<td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
														{{ inquire?.booking_Code }}
												</td>
												<td class="d-flex align-items-center">

														<img *ngIf=" inquire.profileImg  " routerLink="/users/app-edite-user-details/{{ inquire.user_ID }}"
																[src]="inquire?.profileImg"
																style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;">


														<img *ngIf="!inquire.profileImg" routerLink="/users/app-edite-user-details/{{ inquire.user_ID }}"
																src="../../../assets/images/Frame 1261154899.svg"
																style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;">
														{{ inquire?.requested_By_Name }}

												</td>

												<td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
														{{ inquire?.request_Apartment }}
												</td>
												<td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
														{{ inquire?.contact_No }}
												</td>
												<td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
														{{ inquire?.rent_Duration }}
												</td>
												<td>
													<div>

															<span class="rounded-5 px-3 badge Upcoming" *ngIf="inquire?.upcoming=='Upcoming'">

															 {{ inquire?.upcoming}}
															</span>

															<span class="rounded-5 px-3 badge Current" *ngIf="inquire?.upcoming=='Current'">

																{{ inquire?.upcoming}}
															</span>
															<span class="rounded-5 px-3 badge Cancelled" *ngIf="inquire?.upcoming=='Checked Out'">

                                {{ inquire?.upcoming}}
                              </span>

													</div>
											</td>
												<td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
														<div>
																<span class="rounded-5 px-3 badge Completed" *ngIf="inquire?.status=='Completed'">
																		<span>
																				<img src="assets/images/greenDot.svg" alt="">
																		</span>
																		{{ inquire?.status }}
																</span>
																<span class="rounded-5 px-3 badge Approved" *ngIf="inquire?.status=='Approved'">
																		<span>
																				<img src="assets/images/greenDot.svg" alt="">
																		</span>
																		{{ inquire?.status }}
																</span>
																<span class="rounded-5 px-3 badge Cancelled" *ngIf="inquire?.status=='Cancelled'">
																		<span>
																				<img src="assets/images/redDot.svg" alt="">
																		</span>
																		{{ inquire?.status }}
																</span>
																<span class="rounded-5 px-3 badge Pending" *ngIf="inquire?.status=='Pending'">
																		<span>
																				<img src="assets/images/yallowDot.svg" alt="">
																		</span>
																		{{ inquire?.status }}
																</span>
																<span class="rounded-5 px-3  badge Rejected" *ngIf="inquire?.status=='Rejected'">
																		<span>
																				<img src="assets/images/purbleDot.svg" alt="">
																		</span>
																		{{ inquire?.status }}
																</span>
																<span class="rounded-5 px-3  badge Waiting" *ngIf="inquire?.status=='Waiting'">
																		<span>
																				<img src="assets/images/blueDot.svg" alt="">
																		</span>
																		{{ inquire?.status }}
																</span>
																<span class="rounded-5 px-3  badge Waiting" *ngIf="inquire?.status=='CheckedOut'">
																	<span>
																			<img src="assets/images/purbleDot.svg" alt="">
																	</span>
																	{{ inquire?.status }}
															</span>
														</div>
												</td>
												<td class="cursor position-relative" style="text-align: center;">
														<button class="border-0 outlin-0 bg-transparent" (click)="detailperson( $event,inquire.booking_ID)">
																<img src="assets/images/edit.svg">
														</button>
														<div *ngIf="showEdit[inquire.booking_ID] &&checkindex!=1 && inquire?.status!='Approved' && inquire?.status!='Cancelled' && inquire?.status!='Pending' && inquire?.status!='Rejected'"
																class="Actions position-absolute z-3 rounded-3 bg-white border edit-button">
																<button class="d-block border-0 outlin-0 bg-transparent button text-start py-2 w-100"
																		routerLink="/inquiries/inquire-offer/{{ inquire.booking_ID }}">Send Offer </button>
																<button class="d-block border-0 outlin-0 bg-transparent my-2 button text-start py-2 w-100"
																		routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire</button>

																<button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
																		(click)="AddWaitingList(inquire.booking_ID)">Add to waiting list </button>
																<button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
																		(click)="onOpenModal1(inquire.booking_ID)">Reject </button>

														</div>
														<div *ngIf="showEdit[inquire.booking_ID] &&checkindex!=1  && inquire?.status=='Pending'"
																class="Actions position-absolute z-3 rounded-3 bg-white border edit-button">
																<button class="d-block border-0 outlin-0 bg-transparent button text-start py-2 w-100"
																		routerLink="/inquiries/inquire-offer/{{ inquire.booking_ID }}">Send Offer </button>
																<button class="d-block border-0 outlin-0 bg-transparent my-2 button text-start py-2 w-100"
																		routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire</button>

																<button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
																		(click)="onOpenModal1(inquire.booking_ID)">Reject </button>

														</div>
														<div *ngIf="showEdit[inquire.booking_ID] &&checkindex!=1 && inquire?.status=='Approved'  "
																class="Actions position-absolute z-3 rounded-3 bg-white border edit-button">
																<button class="d-block border-0 outlin-0 bg-transparent my-2 button text-start py-2 w-100"
																		routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire</button>
																<button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
																		(click)="onOpenModal1(inquire.booking_ID)">Reject </button>


														</div>
														<div *ngIf="showEdit[inquire.booking_ID] &&checkindex!=1   && inquire?.status=='Cancelled'"
																class="Actions position-absolute z-3 rounded-3 bg-white border edit-button">
																<button class="d-block border-0 outlin-0 bg-transparent my-2 button text-start py-2 w-100"
																		routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire</button>


														</div>
														<div *ngIf="showEdit[inquire.booking_ID] &&checkindex!=1  && inquire?.status=='Rejected'"
																class="Actions position-absolute z-3 rounded-3 bg-white border edit-button">
																<button class="d-block border-0 outlin-0 bg-transparent my-2 button text-start py-2 w-100"
																		routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire</button>

														</div>
												</td>



										</tr>

								</ng-template>


								<ng-template pTemplate="emptymessage">
										<div class="container text-center mt-4">
												<p class="mb-0">No data found.</p>
										</div>
								</ng-template>

						</p-table>
						<p-paginator *ngIf="Inquires.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
							[totalRecords]="totalRecords" [first]="first"></p-paginator>

					 

				</div> -->
<!------------------------------------update------------------------------------------------------>


      <!-----------------------------------------------------------update----------------------------------------------------------------------------->
      <div>
        <div class="p-card p-3" style="border-radius: 16px;" >
          <div class="flex justify-content-between align-items-center mb-4" style="display: flex;">
            <!-- <h2>Subscription Alerts</h2> -->
             <!-- <div class="card-header">Users <span> {{numberTenants}} Users</span></div> -->
             <div class="d-flex mx-2 mt-4">
              <p class="me-2 fs-5 fw-bold ml-8">Inquires</p>
              <p class="mb-3 bg-gray rounded-5 blue px-2 d-flex align-items-center">
                  {{totalRecords}} Inquires
              </p>
          </div>
            <div class="p-inputgroup w-50" style=" position: relative;">
              <!-- <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
              </span> -->
              <input type="text"  class="search-input" pInputText placeholder="      Search any Keywords" [(ngModel)]="globalFilter" (input)="dt2.filterGlobal(globalFilter, 'contains')" />
              <i class="pi pi-search search-icon"></i>
              <!-- <button pButton icon="pi pi-filter" class="p-button-outlined"></button> -->
               <!-- <img src="filterplan.svg" (click)="openFilterDialog()"   style="margin-left: 24px; cursor: pointer;"/> -->
            </div>
          </div>
        <!--[paginator]="true"  [rowsPerPageOptions]="[10, 25, 50]"  [rows]="5"-->
        <p-table
        #dt2
        [value]="Inquires"
        dataKey="booking_ID"


        *ngIf="tableReady"
        [paginator]="true" 
        [rows]="10"

       
        [first]="currentPage"
        (onPage)="onPageChange($event)"
           
        [rowsPerPageOptions]="[10, 20, 50]"
       
        
        
        
        [globalFilterFields]="['booking_Code','requested_By_Name', 'request_Apartment', 'contact_No','rent_Duration','upcoming','status' ]"
        [tableStyle]="{ 'min-width': '75rem' }"

        [customSort]="true"
								(sortFunction)="customSort($event)" 
    >
        <ng-template pTemplate="caption">
            <!-- <div class="flex">
                <p-iconField iconPosition="left" class="ml-auto">
                    <p-inputIcon>
                        <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input 
                        pInputText 
                        type="text" 
                        (input)="dt2.filterGlobal(globalFilter, 'contains')"
                        placeholder="Search keyword" />
                </p-iconField>
            </div> -->
        </ng-template>
        <ng-template pTemplate="header">
            <tr class="headOne">
                <th style="width:22%">Inquiry Id</th>
                <th style="width:22%">User name</th>
                <th style="width:22%">Requested Appartment</th>
                <th style="width:22%">Contact number</th>
                <th style="width:22%" pSortableColumn="rent_Duration">Time period<p-sortIcon field="rent_Duration"></p-sortIcon></th>
                <th style="width:22%"> Booking Type</th> 
                <th style="width:22%">Status</th>
                
                <th style="width:6%">Action</th>

            </tr>
            <tr>
                <th style="width:22%">
                    <p-columnFilter 
                        type="text" 
                        field="booking_Code" 
                        placeholder="Search by Code" 
                        ariaLabel="Filter Code" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text" 
                        field="requested_By_Name" 
                        placeholder="Search by Name" 
                        ariaLabel="Filter Name" />
                </th>
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="request_Apartment" 
                  placeholder="Search by aptName" 
                  ariaLabel="Filter apt_Name" />
                </th>
               
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="contact_No" 
                  placeholder="Search by contact_No" 
                  ariaLabel="Filter contact_No" />
                </th>
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="rent_Duration" 
                  placeholder="Search by period" 
                  ariaLabel="Filter rent_Duration" />
                </th>
                
                  <th>
                    <p-columnFilter field="upcoming" matchMode="equals" [showMenu]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown 
                          [ngModel]="value" 
                          [options]="statuses"
                          optionLabel="label" 
                          optionValue="value"
                          (onChange)="filter($event.value)"  
                          placeholder="Select One" 
                          [showClear]="true">
                          <ng-template let-option pTemplate="item">
                            <p-tag 
                              [value]="option.label" 
                              [severity]="getSeverity(option.label)">
                            </p-tag>
                          </ng-template>
                        </p-dropdown>
                      </ng-template>
                    </p-columnFilter>
                  </th>

                  <th>
                    <p-columnFilter field="status" matchMode="equals" [showMenu]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown 
                          [ngModel]="value" 
                          [options]="statuses2"
                          optionLabel="label" 
                          optionValue="value"
                          (onChange)="filter($event.value)"  
                          placeholder="Select One" 
                          [showClear]="true">
                          <ng-template let-option pTemplate="item">
                            <p-tag 
                              [value]="option.label" 
                              [severity]="getSeverity(option.label)">
                            </p-tag>
                          </ng-template>
                        </p-dropdown>
                      </ng-template>
                    </p-columnFilter>
                  </th>
                  
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-inquire>
          <tr style="cursor: pointer;" (click)="hidecard(inquire.booking_ID)">

            <td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
              {{ inquire?.booking_Code }}
          </td>
          <td class="d-flex align-items-center">

              <img *ngIf=" inquire.profileImg  " routerLink="/users/app-edite-user-details/{{ inquire.user_ID }}"
                  [src]="inquire?.profileImg"
                  style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;">


              <img *ngIf="!inquire.profileImg" routerLink="/users/app-edite-user-details/{{ inquire.user_ID }}"
                  src="../../../assets/images/Frame 1261154899.svg"
                  style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;">
              {{ inquire?.requested_By_Name }}

          </td>

          <td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
              {{ inquire?.request_Apartment }}
          </td>
          <td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
              {{ inquire?.contact_No }}
          </td>
          <td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
              {{ inquire?.rent_Duration }}
          </td>
          <td>
            <div>

                <span class="rounded-5 px-3 badge Upcoming" *ngIf="inquire?.upcoming=='Upcoming'">

                 {{ inquire?.upcoming}}
                </span>

                <span class="rounded-5 px-3 badge Current" *ngIf="inquire?.upcoming=='Current'">

                  {{ inquire?.upcoming}}
                </span>
                <span class="rounded-5 px-3 badge Cancelled" *ngIf="inquire?.upcoming=='Checked Out'">

                  {{ inquire?.upcoming}}
                </span>

            </div>
        </td>
          <td routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">
              <div>
                  <span class="rounded-5 px-3 badge Completed" *ngIf="inquire?.status=='Completed'">
                      <span>
                          <img src="assets/images/greenDot.svg" alt="">
                      </span>
                      {{ inquire?.status }}
                  </span>
                  <span class="rounded-5 px-3 badge Approved" *ngIf="inquire?.status=='Approved'">
                      <span>
                          <img src="assets/images/greenDot.svg" alt="">
                      </span>
                      {{ inquire?.status }}
                  </span>
                  <span class="rounded-5 px-3 badge Cancelled" *ngIf="inquire?.status=='Cancelled'">
                      <span>
                          <img src="assets/images/redDot.svg" alt="">
                      </span>
                      {{ inquire?.status }}
                  </span>
                  <span class="rounded-5 px-3 badge Pending" *ngIf="inquire?.status=='Pending'">
                      <span>
                          <img src="assets/images/yallowDot.svg" alt="">
                      </span>
                      {{ inquire?.status }}
                  </span>
                  <span class="rounded-5 px-3  badge Rejected" *ngIf="inquire?.status=='Rejected'">
                      <span>
                          <img src="assets/images/purbleDot.svg" alt="">
                      </span>
                      {{ inquire?.status }}
                  </span>
                  <span class="rounded-5 px-3  badge Waiting" *ngIf="inquire?.status=='Waiting'">
                      <span>
                          <img src="assets/images/blueDot.svg" alt="">
                      </span>
                      {{ inquire?.status }}
                  </span>
                  <span class="rounded-5 px-3  badge Waiting" *ngIf="inquire?.status=='CheckedOut'">
                    <span>
                        <img src="assets/images/purbleDot.svg" alt="">
                    </span>
                    {{ inquire?.status }}
                </span>
              </div>
          </td>


                <td  >
                


                    <!----------------------------->
                    <div   class="flex justify-content-start align-items-center gab-3" style="display: flex;">
                        <!-- <div><img class="mr-2" style="cursor: pointer;" src="alertUser.svg"/></div> -->
                        <!-- <div class=" ">
                          <img
                          routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}"
                            class="image-default"
                            src="assets/images/viewPay.svg"
                            alt="Default Alert Icon"
                            
                          />
                           
                        </div> -->
                        
                        <div  >
                          <img class="mr-2" style="cursor: pointer;" src="assets/images/threeDotPay.svg" (click)="op.toggle($event)" />
                        </div>
                        <p-overlayPanel #op>
                          <ul *ngIf="  inquire?.status!='Approved' && inquire?.status!='Cancelled' && inquire?.status!='Pending' && inquire?.status!='Rejected'" class="menu-list  " style="width:150px">
                            <li><a      style="cursor: pointer; Color:#363636; text-decoration: none;  "  
                              routerLink="/inquiries/inquire-offer/{{ inquire.booking_ID }}">Send Offer </a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire </a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;" (click)="AddWaitingList(inquire.booking_ID)">Add to waiting list</a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"   (click)="onOpenModal1(inquire.booking_ID)">Reject</a></li>
                          
                          </ul>
                          <!---------------------->
                          <ul style="width:150px" *ngIf="  inquire?.status=='Pending'" class="menu-list ">
                            <li><a      style="cursor: pointer; Color:#363636; text-decoration: none;"  
                              routerLink="/inquiries/inquire-offer/{{ inquire.booking_ID }}">Send Offer </a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire </a></li>
 
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"   (click)="onOpenModal1(inquire.booking_ID)">Reject</a></li>
                          
                          </ul>
                          <!--------------------------->
                          <ul style="width:150px" *ngIf="  inquire?.status=='Approved'  " class="menu-list  ">
 
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire </a></li>
 
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"   (click)="onOpenModal1(inquire.booking_ID)">Reject</a></li>
                          
                          </ul>
                          <!----------------------------->
                          <ul style="width:150px" *ngIf="  inquire?.status=='Cancelled'"  class="menu-list ">
 
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire </a></li>
 
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"   (click)="onOpenModal1(inquire.booking_ID)">Reject</a></li>
                          
                          </ul>
                          <!------------------------------->
                          <ul style="width:150px" *ngIf="  inquire?.status=='Rejected'" class="menu-list">
 
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              routerLink="/inquiries/view-inquire/{{ inquire.booking_ID }}">View inquire </a></li>
 
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"   (click)="onOpenModal1(inquire.booking_ID)">Reject</a></li>
                          
                          </ul>
                        </p-overlayPanel>
                      </div>
                
                </td>
 

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No Inquiries found.</td>
            </tr>
        </ng-template>
</p-table>
<!-- 
	<p-paginator *ngIf="Inquires.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
							[totalRecords]="totalRecords" [first]="first"></p-paginator> -->

        </div>
        
      </div>
      <!---------------------------------------------------------------------------------------------------------------------------------------->

<!------------------------------------------------------------------------------------------>

		</main>
</div>

<div class="modal " tabindex="-1 " role="dialog " [ngStyle]="{ 'display':display1} " style=" background-color: rgb(23 22 22 / 50%);; ">
		<div class="modal-dialog " role="document ">
				<div class="modal-content " style=" margin-top: 150px; ">
						<div class="modal-header " style="position: relative;background-color:#ffffff; border-bottom: none !important; ">
								<p class="modal-title "
										style="color: #1C1B1F; font-size: 20px; font-weight: 600; line-height: 24px; word-wrap: break-word ">
										<span class="form-label gray fw-bold " style="vertical-align: middle; padding-left:8px ">
												Reject inquire
										</span>
								</p>
								<button type="button " style="border:none;background-color: #ffffff;width: 68px;height: 50px; " class="close "
										aria-label="Close " (click)="onCloseModal1() ">
										<span aria-hidden="true " style="color: #000000;font-size: 35px; ">&times;</span>
								</button>


						</div>

						<div class="modal-body ">


								<div class="row ">
										<div class="mb-3 col-12 col-md-12 ">
												<label for="exampleInputPricepermonth " class="form-label gray fw-bold ">Reason</label>
												<textarea class="border p-3 pt-3 rounded-2 w-100 " rows="4 " style="resize: inherit "
														placeholder="please enter reason of rejection " [(ngModel)]="Reason "></textarea>

										</div>
										<!-- <div class="mb-3 col-12 col-md-12 ">
											<label for="exampleInputSecuritydeposit " class="form-label gray fw-bold ">Role discerption</label>
											<textarea class="border p-3 pt-3 rounded-2 w-100 " rows="5 " style="resize: inherit "></textarea>

									</div> -->
								</div>

						</div>


						<div class="modal-footer ">

								<div class="d-flex justify-content-between ">
										<div class="py-2 px-3 fw-bold "></div>
										<div class="d-flex justify-content-between ">
												<a (click)="onCloseModal1() " style=" border: 1px solid; "
														class="backcancel text-decoration-none cursor bg-white rounded-2 py-2 px-3 fw-bold mx-2 xcvdd ">
														Cancel
												</a>
												<button (click)=" CancelRequest( ) " class="rounded-2 text-white rounded-2 border-0 py-2 px-4 "
														style="background-color: #1f4068 !important ">
														confirm
												</button>
										</div>
								</div>
								<!-- Confirm -->

						</div>


				</div>
				<!-- /.modal-content -->
		</div>
		<!-- /.modal-dialog -->
</div>
